var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiAppBarOverrides = function (_a) {
    var palette = _a.palette, tokens = _a.tokens;
    return {
        defaultProps: {
            position: 'fixed',
            color: 'default',
        },
        styleOverrides: {
            root: __assign({ boxShadow: 'none', height: tokens.size_layout_app_bar_height, zIndex: 20, backgroundImage: 'none' }, (palette.mode === 'dark' && {
                borderBottom: "1px solid ".concat(tokens.color_border_default),
            })),
            positionFixed: {
                top: tokens.size_layout_app_top,
            },
            colorDefault: {
                backgroundColor: tokens.color_bg_app_bar,
                color: tokens.color_fg_inverse_static,
            },
        },
    };
};
